<div class="input-wrapper" [ngClass]="{'input-wrapper-blend': blend()}">
	@if (label() || descr()) {
		<div class="input-label">
			@if (label()) {
				<div class="input-label-text">{{label()}}</div>
			}
			@if (descr()) {
				<div class="input-label-descr">{{descr()}}</div>
			}
		</div>
	}
	<div class="input-content">
		<ng-content></ng-content>
		@if (units()) {
			<div class="input-units">{{units()}}</div>
		}
	</div>
</div>